import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiGit,
  DiJava,
  DiDocker,
  DiLaravel,
} from "react-icons/di";
import {
  SiRedis,
  SiPostgresql,
  SiSpringboot,
  SiHibernate,
  SiAmazonaws,
  SiMysql,
  SiFlask,
  SiSwagger,
  SiSonarqube,
} from "react-icons/si";

function Techstack() {
  return (
    <div style={{ paddingBottom: "50px" }}>
      <h2 className="tech-section-title">Languages & Frameworks</h2>
      <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <DiJava />
          <div className="tech-label">Java</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiSpringboot />
          <div className="tech-label">Spring Boot</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiHibernate />
          <div className="tech-label">Hibernate</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiJavascript1 />
          <div className="tech-label">JavaScript</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiLaravel />
          <div className="tech-label">Laravel</div>
        </Col>
      </Row>

      <h2 className="tech-section-title">Databases & Caching</h2>
      <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <SiPostgresql />
          <div className="tech-label">PostgreSQL</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiMysql />
          <div className="tech-label">MySQL</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiRedis />
          <div className="tech-label">Redis</div>
        </Col>
      </Row>

      <h2 className="tech-section-title">DevOps, Tools & Others</h2>
      <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <DiDocker />
          <div className="tech-label">Docker</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiAmazonaws />
          <div className="tech-label">AWS</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiSwagger />
          <div className="tech-label">Swagger</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiSonarqube />
          <div className="tech-label">SonarQube</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiFlask />
          <div className="tech-label">Flask</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiGit />
          <div className="tech-label">Git</div>
        </Col>
      </Row>
    </div>
  );
}

export default Techstack;
